import { Component } from "react";
import PropTypes from "prop-types";

export default class Debounce extends Component {
  static propTypes = {
    ms: PropTypes.number.isRequired,
    children: PropTypes.any.isRequired,
  };

  componentWillReceiveProps() {
    if (this.lastScheduledTimeout) {
      clearTimeout(this.lastScheduledTimeout);
    }

    const { ms } = this.props;
    this.lastScheduledTimeout = setTimeout(this.scheduleUpdate, ms);
  }

  shouldComponentUpdate = () => false;

  componentWillUnmount() {
    this.didUnmount = true;
    clearTimeout(this.lastScheduledTimeout);
  }

  scheduleUpdate = () => {
    if (this.didUnmount === false) {
      this.forceUpdate();
    }
  };

  didUnmount = false;

  render() {
    const { children } = this.props;
    return children;
  }
}
